import { createUseStyles } from "react-jss";
export function useStylesHook(styles) {
    var useStyles = createUseStyles(styles);
    return useStyles();
}
